import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { getErrorCode, isApiError } from './request-error';
const isString = (x: unknown): x is string => typeof x === 'string' && !!x;
const useRequestError = () => {
  const $0 = _c(6);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "errors"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("request", t0);
  let t1;
  if ($0[1] !== t) {
    t1 = code => !!code?.match(/^E[0-9]+$/g) && !!t($ => $[code as keyof typeof $], {
      defaultValue: ""
    });
    $0[1] = t;
    $0[2] = t1;
  } else {
    t1 = $0[2];
  }
  const isValidErrorCode = t1;
  const getContext = _temp;
  let t2;
  if ($0[3] !== isValidErrorCode || $0[4] !== t) {
    const getMessage = error_0 => {
      if (isString(error_0)) {
        return error_0;
      }
      const unknownError = t(_temp2);
      if (isApiError(error_0)) {
        const errorCode = error_0.code;
        const errorContext = error_0.context;
        const errorMessage = error_0.message;
        if (!errorCode || !isValidErrorCode(errorCode)) {
          return errorMessage ?? unknownError;
        }
        if (!errorContext) {
          return t($_1 => $_1[errorCode as keyof typeof $_1]) ?? unknownError;
        }
        return t($_2 => $_2[errorCode as keyof typeof $_2], errorContext) ?? unknownError;
      }
      if (typeof error_0 === "object" && error_0 != null && "message" in error_0 && typeof error_0.message === "string") {
        return error_0.message;
      }
      return unknownError;
    };
    const getStatusCode = _temp3;
    t2 = {
      getErrorMessage: getMessage,
      getErrorCode,
      getErrorContext: getContext,
      getErrorStatusCode: getStatusCode
    };
    $0[3] = isValidErrorCode;
    $0[4] = t;
    $0[5] = t2;
  } else {
    t2 = $0[5];
  }
  return t2;
};
export { useRequestError };
function _temp(error) {
  if (isApiError(error)) {
    return error.context || {};
  }
  return {};
}
function _temp2($_0) {
  return $_0.unknown;
}
function _temp3(error_1) {
  if (!error_1 || !isApiError(error_1)) {
    return;
  }
  return error_1.status ?? undefined;
}